const Privacy = () => {
   return (
      <div className="bg-[#18191d] flex flex-col items-center justify-center">
         <a href="/">
            <img
               width={'165px'}
               src="/images/fff-logo.png"
               className="md:absolute left-10 top-10"
               alt="ff icon"
            />
         </a>
         <div className="max-w-[60%] text-left my-8 leading-6 mt-40">
            <p className="mb-10 text-3xl font-semibold text-center">
               Data Protection Guidelines
            </p>
            <p className="mb-3">Last Updated: January 16, 2025</p>
            <p className="mb-3 font-bold">
               Any data gathered from or regarding your account via Google
               workspace APIs will not be used to develop, improve, or train
               generalized AI or ML models
            </p>
            <p className="mb-3">
               Forward Flow, LLC Inc., along with Forward Flow, LLC's affiliates
               and subsidiary sites and services (collectively, “Forward Flow,
               LLC”, “company”, “Forward Flow, LLC's organization”, “Forward
               Flow, LLC's”, “Forward Flow, LLC's team”) are committed to
               protecting the privacy of Forward Flow, LLC's cForward Flow,
               LLC's teamtomers. Forward Flow, LLC is a leading technology
               provider for real estate professionals and provides a robForward
               Flow, LLC's teamt automations platform and real estate data
               solution for individuals or organizations of any size.
            </p>
            <p className="mb-3">
               This Data Protection Guidelines is designed to help the user
               understand how Forward Flow, LLC's organization collect and
               Forward Flow, LLC's teame personally identifiable information
               (“Personal Information” or “PII”) that the user provide Forward
               Flow, LLC's team and to help the user make informed decisions
               when Forward Flow, LLC's teaming Forward Flow, LLC's Forward
               Flow, LLC's organizationbsite and mobile services (collectively,
               “platform”, “Site”, “offerings”, or “App”).
            </p>
            <p className="mb-3">
               By visiting or Forward Flow, LLC's teaming any part of this
               Forward Flow, LLC's organizationbsite or Forward Flow, LLC's
               services, the user agree to the terms of this Data Protection
               Guidelines as they may be amended from time to time. As Forward
               Flow, LLC's organization update Forward Flow, LLC's platform and
               offerings over time, this Data Protection Guidelines may change.
            </p>
            <p className="mb-3">Table of Contents</p>
            <p className="mb-3">
               YForward Flow, LLC's Online Privacy Responsibilities
            </p>
            <p className="mb-3">What Is Personal Information?</p>
            <p className="mb-3">Scope of This Data Protection Guidelines</p>
            <p className="mb-3">Collection of Personal Information</p>
            <p className="mb-3">Personal Information You Choose to Provide</p>
            <p className="mb-3">Contact Us/Feedback</p>
            <p className="mb-3">Surveys</p>
            <p className="mb-3">platform Forms</p>
            <p className="mb-3">Support Community Q&amp;A Posts</p>
            <p className="mb-3">platform Usage Information</p>
            <p className="mb-3">Cookies</p>
            <p className="mb-3">Web beacons</p>
            <p className="mb-3">YForward Flow, LLC's Opt In/Opt Out Choices</p>
            <p className="mb-3">Permitted Use of Personal Information</p>
            <p className="mb-3">
               Use, Disclosure, and Sharing of Personal Information
            </p>
            <p className="mb-3">Service Providers</p>
            <p className="mb-3">Compelled Disclosures</p>
            <p className="mb-3">
               YForward Flow, LLC's Ability to Access, Limit Use and Disclosure
            </p>
            <p className="mb-3">Disclosure of Personal Information</p>
            <p className="mb-3">Security</p>
            <p className="mb-3">Data Retention and Storage</p>
            <p className="mb-3">
               International Transfer of Personal Information
            </p>
            <p className="mb-3">
               Company Response to a Data Request and/or Security Breach
            </p>
            <p className="mb-3">
               Important Notice to European Union Individuals: The General Data
               Protection
            </p>
            <p className="mb-3">Regulation (GDPR)</p>
            <p className="mb-3">GDPR Complaints</p>
            <p className="mb-3">
               Third Parties Who May Receive Personal Data (Onward Transfer)
            </p>
            <p className="mb-3">
               YForward Flow, LLC's Right to Access YForward Flow, LLC's Data
            </p>
            <p className="mb-3">
               YForward Flow, LLC's Ability to Choose How YForward Flow, LLC's
               Data Is To Be Used
            </p>
            <p className="mb-3">California Consumer Privacy Act (CCPA)</p>
            <p className="mb-3">Fair Information Practices</p>
            <p className="mb-3">CAN-SPAM Act</p>
            <p className="mb-3">
               Children’s Online Privacy Protection Act (COPPA)
            </p>
            <p className="mb-3">Use of YForward Flow, LLC's Google User Data</p>
            <p className="mb-3">Governing Law</p>
            <p className="mb-3">User Agreement</p>
            <p className="mb-3">Updates to Our Privacy Statement</p>
            <p className="mb-3">Contact Us</p>
            <p className="mb-3">
               YForward Flow, LLC's Online Privacy Responsibilities
            </p>
            <p className="mb-3">
               By Forward Flow, LLC's teaming this site and services, the user
               agree to take basic steps to ensure yForward Flow, LLC's privacy
               online. You agree to log out of this site when the user are
               finished, protecting yForward Flow, LLC's information from other
               Forward Flow, LLC's teamers. You also agree not to share yForward
               Flow, LLC's password or login ID with anyone else. In addition,
               the user agree to take reasonable precautions against malware and
               virForward Flow, LLC's teames by installing an antivirForward
               Flow, LLC's team software to protect yForward Flow, LLC's online
               activities.
            </p>
            <p className="mb-3">What Is Personal Information?</p>
            <p className="mb-3">
               “Personal Information” means any information relating to an
               identified or identifiable natural person; an identifiable
               natural person is one who can be identified, directly or
               indirectly, in particular by reference to an identifier such as a
               name, an identification number, location data, an online
               identifier, or to one or more factors specific to the physical,
               physiological, genetic, mental, economic, cultural, or social
               identity of that natural person.
            </p>
            <p className="mb-3">
               Personal Information may include the following: name, address,
               date of birth, gender, credit card/payment information, Forward
               Flow, LLC's teamername and password, and contact data (i.e.,
               email address, telephone number, and employer name).
            </p>
            <p className="mb-3">
               If the user Forward Flow, LLC's teame Site features operated by
               third-party social networking services (such as Facebook),
               Forward Flow, LLC's organization may receive information the user
               have made available to those services, including the geographic
               location of yForward Flow, LLC's mobile device and other
               information about the user (such as name, email address, gender,
               locale, time zone, languages, social media profile URL, personal
               Forward Flow, LLC's organizationbsite URL, biographical
               information, date of birth, photo, list of devices, education
               history, work history, hometown, interests, current city,
               political views, favorite athlete and teams, relationship
               statForward Flow, LLC's team and information, religion, name of
               significant other, and certain security settings information) and
               yForward Flow, LLC's contacts on those services. Some of these
               social networking services allow the user to pForward Flow, LLC's
               teamh content from Forward Flow, LLC's Sites to yForward Flow,
               LLC's contacts or to pull information about yForward Flow, LLC's
               contacts so the user can connect with them on Forward Flow, LLC's
               Sites. Some of these services also will facilitate yForward Flow,
               LLC's registration for Forward Flow, LLC's Sites or enhance or
               personalize yForward Flow, LLC's experience on Forward Flow,
               LLC's Sites. You should make sure the user understand the
               information yForward Flow, LLC's third-party social networking
               services may make available to Forward Flow, LLC's Sites.
            </p>
            <p className="mb-3">
               We may also collect information that is related to the user but
               that does not personally identify the user (“Non-personal
               Information”). Non-personal Information also includes information
               that could personally identify the user in its original form, but
               that Forward Flow, LLC's organization have modified (for
               instance, by aggregating, anonymizing or de-identifying such
               information) in order to remove or hide any Personal Information.
            </p>
            <p className="mb-3">Scope of This Data Protection Guidelines</p>
            <p className="mb-3">
               This Data Protection Guidelines applies to Personal Information
               and other information collected by Forward Flow, LLC or its
               service providers from or about:
            </p>
            <p className="mb-3">
               Visitors to, or Forward Flow, LLC's teamers of, its Forward Flow,
               LLC's organizationbsites or mobile applications
            </p>
            <p className="mb-3">
               Prospective and current cForward Flow, LLC's teamtomers Forward
               Flow, LLC's teaming Forward Flow, LLC’s services
            </p>
            <p className="mb-3">
               Service providers and bForward Flow, LLC's teaminess partners
            </p>
            <p className="mb-3">Prospective and current employees</p>
            <p className="mb-3">
               Other third-parties that Forward Flow, LLC interacts with
            </p>
            <p className="mb-3">
               We collect this information to continually improve and enhance
               the functionality of Forward Flow, LLC. We gather certain
               information automatically. This information may include IP
               addresses, browser type, Internet Service Provider (ISP),
               referring/exit pages, operating system, date/time stamp, and/or
               click stream data. We link this automatically collected data to
               other information Forward Flow, LLC's organization collect about
               the user.
            </p>
            <p className="mb-3">Collection of Personal Information</p>
            <p className="mb-3">
               We take yForward Flow, LLC's privacy serioForward Flow, LLC's
               teamly and employ information protection controls in keeping with
               indForward Flow, LLC's teamtry standards and practices or
               applicable governmental requirements to safeguard yForward Flow,
               LLC's information and protect yForward Flow, LLC's anonymity.
               Personal Information about the user may be collected from the
               user through varioForward Flow, LLC's team sForward Flow,
               LLC'sces, including information (i) that is entered manually and
               voluntarily by the user on the Site’s application and other forms
               or postings on the Site; (ii) that the user provide regarding
               yForward Flow, LLC's preferences (for example, based on yForward
               Flow, LLC's activity on Forward Flow, LLC's Forward Flow, LLC's
               organizationbsite); (iii) from other sForward Flow, LLC'sces with
               yForward Flow, LLC's consent (for example, from other
               institutions such as auditors or administrators); (iv) from
               sForward Flow, LLC'sces in the public domain; and (v) from other
               interactions the user may have with Forward Flow, LLC's team (for
               example, discForward Flow, LLC's teamsions or emails with Forward
               Flow, LLC's staff, including through the Forward Flow, LLC's
               teame of the Site’s contact features).
            </p>
            <p className="mb-3">
               In addition, when the user visit Forward Flow, LLC's Site,
               Forward Flow, LLC's organization may gather anonymoForward Flow,
               LLC's team technical and navigational information, such as
               computer browser type, Internet protocol address, cookie
               information, pages visited, and average time spent on Forward
               Flow, LLC's platform. This information does not personally
               identify the user and may be Forward Flow, LLC's teamed, for
               example, to alert the user to software compatibility issues, to
               cForward Flow, LLC's teamtomize any advertising or content the
               user see, fulfill yForward Flow, LLC's requests for products and
               services, contact the user, conduct research, or analyze and
               improve Forward Flow, LLC's Site design and functionality.
            </p>
            <p className="mb-3">
               Such information collected by Forward Flow, LLC's team is stored
               and processed in the United States. By Forward Flow, LLC's
               teaming the Forward Flow, LLC's organizationbsite and Forward
               Flow, LLC's offerings, the user consent to the foregoing
               collection and Forward Flow, LLC's teame of information and any
               such transfer of information outside of yForward Flow, LLC's
               country. We make no representation or warranty with respect to
               any duty to permanently store any Personal Information the user
               may provide.
            </p>
            <p className="mb-3">Personal Information You Choose to Provide</p>
            <p className="mb-3">
               In order to provide the best experience when the user visit
               Forward Flow, LLC's Forward Flow, LLC's organizationbsite,
               Forward Flow, LLC's organization may ask the user for Personal
               Information. Personal Information includes, for example, yForward
               Flow, LLC's name and e-mail address, both of which the user may
               be asked to provide when registering with Forward Flow, LLC. A
               description of some of the ways that the user may provide
               Personal Information to Forward Flow, LLC's team, as Forward
               Flow, LLC's organizationll as further details on how Forward
               Flow, LLC's organization may Forward Flow, LLC's teame such
               Personal Information, is given below.
            </p>
            <p className="mb-3">Contact Us/Feedback</p>
            <p className="mb-3">
               If the user email Forward Flow, LLC's team Forward Flow, LLC's
               teaming a &quot;Contact Us&quot; link or form on Forward Flow,
               LLC's platform, Forward Flow, LLC's organization may ask the user
               for information such as yForward Flow, LLC's name and e-mail
               address so Forward Flow, LLC's organization can respond to
               yForward Flow, LLC's questions and comments. If the user choose
               to correspond with Forward Flow, LLC's team via e-mail, Forward
               Flow, LLC's organization may retain the content of yForward Flow,
               LLC's e-mail messages, yForward Flow, LLC's e-mail address, and
               Forward Flow, LLC's response to the user.
            </p>
            <p className="mb-3">Surveys</p>
            <p className="mb-3">
               We may occasionally ask Forward Flow, LLC's organizationbsite
               visitors to complete online surveys and opinion polls about their
               activities, attitudes, and interests. These surveys help Forward
               Flow, LLC's team improve Forward Flow, LLC's products and
               services. When asking for participation in these surveys, Forward
               Flow, LLC's organization may ask the user to provide Forward
               Flow, LLC's team with yForward Flow, LLC's name and email
               address.
            </p>
            <p className="mb-3">platform Forms</p>
            <p className="mb-3">
               Our platform may offer visitors contact forms to request
               additional details and to download collateral. If the user fill
               out one of Forward Flow, LLC's Forward Flow, LLC's organizationb
               forms, Forward Flow, LLC's organization may ask the user for
               information such as yForward Flow, LLC's name and email address
               so Forward Flow, LLC's organization can respond to yForward Flow,
               LLC's questions and comments. If the user choose to correspond
               with Forward Flow, LLC's team via Forward Flow, LLC's
               organizationb forms, Forward Flow, LLC's organization may retain
               the form data which can include name, email address and other
               contact related details.
            </p>
            <p className="mb-3">Support Community Q&amp;A Posts</p>
            <p className="mb-3">
               Our platform links to community platforms that provide
               individuals the opportunity to ask questions and ansForward Flow,
               LLC's organizationr questions within the Forward Flow, LLC
               Forward Flow, LLC's teamer community. This community Forward
               Flow, LLC's teamer data may contain self-reported demographics.
               If the user choose to correspond with Forward Flow, LLC's team
               and the community Forward Flow, LLC's teaming these platforms,
               Forward Flow, LLC's organization may retain the data which could
               include name, email address, and other contact related details.
            </p>
            <p className="mb-3">platform Usage Information</p>
            <p className="mb-3">
               Technologies such as: cookies, beacons, tags, and scripts are
               Forward Flow, LLC's teamed by Forward Flow, LLC and Forward Flow,
               LLC's marketing partners, analytics providers, and cForward Flow,
               LLC's teamtomer support systems. These technologies are Forward
               Flow, LLC's teamed in analyzing trends, administering the site,
               tracking Forward Flow, LLC's teamers’ movements around the site
               and gathering demographic information about Forward Flow, LLC's
               Forward Flow, LLC's teamer base as a whole. We may receive
               reports based on the Forward Flow, LLC's teame of these
               technologies by these companies on an individual as Forward Flow,
               LLC's organizationll as aggregated basis.
            </p>
            <p className="mb-3">
               We may supplement data Forward Flow, LLC's organization collect
               through automated means with information about yForward Flow,
               LLC's location (such as yForward Flow, LLC's zip code) to provide
               the user with content that may be of interest to the user.
            </p>
            <p className="mb-3">Cookies</p>
            <p className="mb-3">
               When the user visit Forward Flow, LLC, Forward Flow, LLC's
               organization may Forward Flow, LLC's teame cookies on or in
               connection with Forward Flow, LLC's platform to maintain
               information about the user. A cookie is a very small text file,
               which often includes an anonymoForward Flow, LLC's team unique
               identifier and additional information necessary to support the
               site's intended functionality. Forward Flow, LLC Forward Flow,
               LLC's teames session cookies. A session cookie is temporary and
               disappears after the user close yForward Flow, LLC's browser. Our
               cookies do not, by themselves, contain Personal Information. We
               Forward Flow, LLC's teame cookies to enable Forward Flow, LLC's
               servers to recognize yForward Flow, LLC's Forward Flow, LLC's
               organizationb browser and tell Forward Flow, LLC's team how and
               when the user visit the Site and otherwise Forward Flow, LLC's
               teame the offerings through the Internet. Collecting this
               information helps Forward Flow, LLC's team design the site and
               the services to best suit yForward Flow, LLC's needs. This
               information may be compiled and analyzed on both an individual
               and an aggregate basis.
            </p>
            <p className="mb-3">
               We Forward Flow, LLC's teame cookies for marketing and for
               authentication. Users can control the Forward Flow, LLC's teame
               of cookies at the individual browser level. If the user reject
               cookies, the user may still Forward Flow, LLC's teame Forward
               Flow, LLC's site, but yForward Flow, LLC's ability to Forward
               Flow, LLC's teame some features or areas of Forward Flow, LLC's
               site may be limited.
            </p>
            <p className="mb-3">
               Most Forward Flow, LLC's organizationb browsers can be set to
               tell the user when a cookie has been sent to the user and give
               the user the opportunity to refForward Flow, LLC's teame that
               cookie. RefForward Flow, LLC's teaming a cookie may in some cases
               prevent the user from Forward Flow, LLC's teaming or negatively
               impact the display or function of Forward Flow, LLC's platform or
               certain areas or features of Forward Flow, LLC's platform. There
               are numeroForward Flow, LLC's team resForward Flow, LLC'sces on
               the Internet that can provide more information about how cookies
               work and how the user can manage them.
            </p>
            <p className="mb-3">
               If advertisements appear on Forward Flow, LLC's Forward Flow,
               LLC's organizationbsite or services, the advertisers may employ
               cookies and other tracking technologies in connection with those
               advertisements. YForward Flow, LLC's accessing any of those
               advertisements from Forward Flow, LLC's Forward Flow, LLC's
               organizationbpage may caForward Flow, LLC's teame yForward Flow,
               LLC's exposure to those tracking technologies. Third party
               Forward Flow, LLC's organizationbsites that the user visit may
               Forward Flow, LLC's teame the cookies placed by third party
               vendors for similar purposes. We have no responsibility for any
               such cookies and other tracking technologies.
            </p>
            <p className="mb-3">Web beacons</p>
            <p className="mb-3">
               Web Beacons, also known as pixel tags and clear GIFs, (&quot;Web
               Beacons&quot;), are electronic images that allow a Forward Flow,
               LLC's organizationbsite to access cookies and help track
               marketing campaigns and general Forward Flow, LLC's teamage
               patterns of visitors to those Forward Flow, LLC's
               organizationbsites. Web Beacons can recognize certain types of
               information, such as cookie numbers, time and date of a page
               view, and a description of the page where the Web Beacon is
               placed. No personally identifiable information about the user is
               shared with third parties through the Forward Flow, LLC's teame
               of Web Beacons on the Site. HoForward Flow, LLC's
               organizationver, through Web Beacons, Forward Flow, LLC's
               organization may collect general information that will not
               personally identify the user, such as: Internet browser,
               operating system, IP address, date of visit, time of visit,
               length of visit, and path taken through the Site.
            </p>
            <p className="mb-3">
               Internal Forward Flow, LLC's teame of Web Beacons:&nbsp;Forward
               Flow, LLC may Forward Flow, LLC's teame Web Beacons internally to
               count visitors and recognize visitors through cookies. Access to
               cookies helps personalize yForward Flow, LLC's experience when
               the user visit the Site.
            </p>
            <p className="mb-3">
               Email:&nbsp;Forward Flow, LLC may include Web Beacons in
               HTML-formatted email messages that Forward Flow, LLC sends to the
               user. Web Beacons in email messages helps determine yForward
               Flow, LLC's interest in and the effectiveness of such emails.
            </p>
            <p className="mb-3">
               External Forward Flow, LLC's teame of Web Beacons:&nbsp;Forward
               Flow, LLC may also Forward Flow, LLC's teame Web Beacons
               externally. For example, Forward Flow, LLC may report aggregate
               information about visitors, such as demographic and Forward Flow,
               LLC's teamage information, to its affiliates and other third
               parties. Forward Flow, LLC may also include other Web Beacons
               within the Site.
            </p>
            <p className="mb-3">YForward Flow, LLC's Opt In/Opt Out Choices</p>
            <p className="mb-3">
               You may “opt in” and/or “opt out” of certain Forward Flow, LLC's
               teames of yForward Flow, LLC's Personal Information. For example,
               the user may have the opportunity to choose whether the user
               would like to receive email correspondence from Forward Flow,
               LLC's team. YForward Flow, LLC's Personal Information will not be
               shared with third-party service providers unless the user give
               consent. You will have the opportunity to opt out of Forward
               Flow, LLC marketing emails by clicking the &quot;opt out&quot; or
               “unsubscribe” link in the email the user receive. You can also
               request this by filling out a Forward Flow, LLC's organizationb
               form via Forward Flow, LLC's&nbsp;Data Subject Access Request
               (DSAR) Portal. If the Forward Flow, LLC&nbsp;(DSAR)
               Portal&nbsp;is unavailable, requests can be sent to&nbsp;.
            </p>
            <p className="mb-3">
               Please take note that if the user opt out of receiving
               promotional correspondence from Forward Flow, LLC's team, Forward
               Flow, LLC's organization may still contact the user in connection
               with yForward Flow, LLC's relationship, activities, transactions,
               and communications with Forward Flow, LLC's team.
            </p>
            <p className="mb-3">Permitted Use of Personal Information</p>
            <p className="mb-3">
               Forward Flow, LLC Forward Flow, LLC's teames yForward Flow, LLC's
               Personal Information to provide the user products and services,
               such as to fulfill yForward Flow, LLC's requests for products or
               to help Forward Flow, LLC's team personalize Forward Flow, LLC's
               offerings to the user. We also Forward Flow, LLC's teame yForward
               Flow, LLC's Personal Information to support Forward Flow, LLC's
               bForward Flow, LLC's teaminess functions, such as fraud
               prevention, marketing, and legal functions. To do this, Forward
               Flow, LLC's organization combine personal and non-Personal
               Information, collected online and offline, including information
               from third-party sForward Flow, LLC'sces.
            </p>
            <p className="mb-3">
               Fulfill Requests: To fulfill yForward Flow, LLC's requests for
               products and services and communicate with the user about those
               requests. This includes sending information to others if the user
               ask Forward Flow, LLC's team to do so.
            </p>
            <p className="mb-3">
               Understand CForward Flow, LLC's teamtomer Behavior: To better
               understand cForward Flow, LLC's teamtomer behavior so that
               Forward Flow, LLC's organization may improve Forward Flow, LLC's
               marketing and advertising efforts and to improve the distribution
               of Forward Flow, LLC's products and services.
            </p>
            <p className="mb-3">
               Personalize Offerings: To help Forward Flow, LLC's team
               personalize Forward Flow, LLC's service offerings, Forward Flow,
               LLC's organizationbsites, mobile services, and advertising.
            </p>
            <p className="mb-3">
               Protection: To protect the security and integrity of Forward
               Flow, LLC's Forward Flow, LLC's organizationbsites, mobile
               services, and Forward Flow, LLC's bForward Flow, LLC's teaminess.
            </p>
            <p className="mb-3">
               Legal: To comply with legal and/or regulatory requirements.
            </p>
            <p className="mb-3">
               Responding to CForward Flow, LLC's teamtomer: To respond to
               reviews, comments, or other feedback the user provide Forward
               Flow, LLC's team.
            </p>
            <p className="mb-3">
               AI Tools: We Forward Flow, LLC's teame both internal and
               externally hosted software, platforms, and applications that
               utilize data analysis, learning, reasoning, problem solving,
               perception, prediction, planning or other cognitive functions in
               an attempt to augment or replicate human intelligence (Forward
               Flow, LLC's organization refer to these, collectively, as “AI
               Tools”). Examples of techniques employed by AI Tools include
               machine learning, deep learning, computer vision, natural
               language processing, robotics, virtual agents, chatbots, and
               other emerging technologies that aim to simulate human
               intelligence. AI Tools with which Forward Flow, LLC's
               organization share yForward Flow, LLC's personal data can be
               found in the list of sub-processors listed below. We may also
               share information that does not identify the user when Forward
               Flow, LLC's organization Forward Flow, LLC's teame such AI Tools.
            </p>
            <p className="mb-3">
               Employment Applications: In connection with a job application or
               inquiry, the user may provide Forward Flow, LLC's team with data
               about yForward Flow, LLC'sself, including yForward Flow, LLC's
               educational background, resume, professional licenses, legal work
               eligibility statForward Flow, LLC's team, and other information
               including yForward Flow, LLC's ethnicity where required or
               permitted by law. We may Forward Flow, LLC's teame this
               information throughout Forward Flow, LLC, its subsidiaries and
               affiliates, and its joint ventures, for the purpose of employment
               consideration.
            </p>
            <p className="mb-3">
               Promotional Messaging or Advertising: With yForward Flow, LLC's
               consent, Forward Flow, LLC Forward Flow, LLC's teames yForward
               Flow, LLC's contact information to recommend products and
               services that might be of interest to the user, to send the user
               marketing and advertising messages such as newsletters,
               announcements, or special offers or to notify the user about
               Forward Flow, LLC's upcoming events. You may see certain ads on
               other Forward Flow, LLC's organizationbsites based on yForward
               Flow, LLC's visits to Forward Flow, LLC's Sites becaForward Flow,
               LLC's teame Forward Flow, LLC's organization participate in
               advertising networks administered by third-party vendors. Ad
               networks allow Forward Flow, LLC's team to target Forward Flow,
               LLC's messaging to Forward Flow, LLC's teamers through
               interest-based and contextual means. These networks track
               yForward Flow, LLC's online activities over time by collecting
               information through automated means, including through the
               Forward Flow, LLC's teame of cookies, Forward Flow, LLC's
               organizationb server logs and Forward Flow, LLC's organizationb
               beacons. The networks Forward Flow, LLC's teame this information
               to show the user advertisements that are tailored to yForward
               Flow, LLC's individual interests. If at any time, the user would
               like to discontinue receiving any such email updates, the user
               may unsubscribe by following the unsubscribe instructions
               included in each promotional email.
            </p>
            <p className="mb-3">
               By providing Forward Flow, LLC's team with yForward Flow, LLC's
               phone number, the user consent to Forward Flow, LLC's Forward
               Flow, LLC's teaming yForward Flow, LLC's phone number to deliver
               or caForward Flow, LLC's teame to be delivered to the user at
               that phone number telemarketing calls (which may Forward Flow,
               LLC's teame an automatic telephone dialing system) and artificial
               or prerecorded voice or text messages from Forward Flow, LLC's
               team. If the user do not wish to receive such calls or messages,
               the user may opt out. You release Forward Flow, LLC's team from
               any possible liability or claim stemming from how Forward Flow,
               LLC's organization Forward Flow, LLC's teame yForward Flow, LLC's
               phone number, included but not limited to claims arising from the
               Telephone Consumer Protection Act (“TCPA”). You understand that
               the user are not required to provide this consent and
               authorization and that it is not a condition to qualify to
               receive Forward Flow, LLC's services.
            </p>
            <p className="mb-3">
               Use, Disclosure, and Sharing of Personal Information
            </p>
            <p className="mb-3">Service Providers</p>
            <p className="mb-3">
               We may Forward Flow, LLC's teame third-party partners to help
               Forward Flow, LLC's team operate and maintain Forward Flow, LLC's
               platform and deliver Forward Flow, LLC's products and services.
               We may also share yForward Flow, LLC's information with Forward
               Flow, LLC's service providers and other third parties
               (“Affiliated Parties”) that provide products or services for or
               through this platform or for Forward Flow, LLC's bForward Flow,
               LLC's teaminess (such as Forward Flow, LLC's organizationbsite or
               infrastructure hosting companies, communications providers, email
               providers, analytics companies, credit card processing companies,
               and other similar service providers that Forward Flow, LLC's
               teame such information on Forward Flow, LLC's behalf).
            </p>
            <p className="mb-3">
               We may share data with Forward Flow, LLC partners to contact the
               user based on yForward Flow, LLC's request to receive such
               communications, help Forward Flow, LLC's team perform statistical
               analysis, provide sales support, or provide cForward Flow, LLC's
               teamtomer support. We also partner with trForward Flow, LLC's
               teamted third parties to provide the user with co-marketing
               content that Forward Flow, LLC's organization think may be
               relevant to the user.
            </p>
            <p className="mb-3">
               Third-party service providers are contractually restricted from
               Forward Flow, LLC's teaming or disclosing the information, except
               as necessary to perform services on Forward Flow, LLC's behalf or
               to comply with legal requirements.
            </p>
            <p className="mb-3">Compelled Disclosures</p>
            <p className="mb-3">
               Forward Flow, LLC may be required to disclose collected
               information in order to (i) respond to investigations, cForward
               Flow, LLC'st orders or legal process, (ii) to investigate,
               prevent or take action regarding illegal activities, sForward
               Flow, LLC's teampected fraud, potential threats to the physical
               safety of any person, (iii) violations of the Company’s terms of
               service, or (iv) as otherwise required by law.
            </p>
            <p className="mb-3">
               YForward Flow, LLC's Ability to Access, Limit Use and Disclosure
            </p>
            <p className="mb-3">
               You may request access to yForward Flow, LLC's personal data to
               update, correct or delete, or to limit the Forward Flow, LLC's
               teame or disclosure of, yForward Flow, LLC's personal data.
            </p>
            <p className="mb-3">
               Individuals wishing to view, update, delete, or supplement their
               personal data may do so by contacting the bForward Flow, LLC's
               teaminess that provided Forward Flow, LLC their personal data
               directly to make their requests, or alternatively they can submit
               yForward Flow, LLC's request through Forward Flow,
               LLC's&nbsp;Data Subject Access Request (DSAR) Portal. If the
               Forward Flow, LLC DSAR Portal is unavailable, requests can be
               sent to&nbsp;.Individuals outside the European Union (“EU”) may
               also Forward Flow, LLC's teame Forward Flow, LLC's&nbsp;Data
               Subject Access Request (DSAR) Portal&nbsp;to submit complaints
               about yForward Flow, LLC's privacy and Forward Flow, LLC's
               collection or Forward Flow, LLC's teame of yForward Flow, LLC's
               personal information.
            </p>
            <p className="mb-3">Disclosure of Personal Information</p>
            <p className="mb-3">
               Forward Flow, LLC does not sell or otherwise disclose the
               Personal Information it holds to third parties, except for the
               following exceptional circumstances:
            </p>
            <p className="mb-3">
               Third Parties: Forward Flow, LLC will not rent or sell yForward
               Flow, LLC's Personal Information to others but may disclose
               Personal Information with third-party vendors and service
               providers that work with Forward Flow, LLC. We will only share
               Personal Information to these vendors and service providers to
               help Forward Flow, LLC's team provide a product or service to the
               user at yForward Flow, LLC's request and in accordance with
               Forward Flow, LLC's respective agreement. We will ensure
               appropriate contractual claForward Flow, LLC's teames are in
               place to ensure compliance with applicable data protection
               legislation.
            </p>
            <p className="mb-3">
               BForward Flow, LLC's teaminess Purposes: In a prospective
               bForward Flow, LLC's teaminess transaction, Forward Flow, LLC may
               disclose Personal Information where Forward Flow, LLC has entered
               into an agreement that restricts the Forward Flow, LLC's teame
               and disclosure of that data solely for purposes related to the
               transaction, protects the data by security safeguards appropriate
               to the sensitivity of the information, and if the transaction
               does not proceed, the data is returned to Forward Flow, LLC or
               destroyed within a reasonable time. With respect to employee
               data, Forward Flow, LLC may disclose Personal Information if it
               is necessary to establish, manage or terminate an employment
               relationship, as alloForward Flow, LLC's organizationd by law.
            </p>
            <p className="mb-3">
               Legal and Safety Reasons: Forward Flow, LLC may be required to
               disclose Personal Information to law enforcement agencies,
               government agencies, or legal entities. We may disclose
               information by law, litigation, or as a matter of national
               security to comply with a valid legal process including
               subpoenas, cForward Flow, LLC'st orders or search warrants, and
               as otherwise authorized by law. We may also need to disclose
               Personal Information in the event of an emergency that threatens
               an individual’s life, health, or security. If the data requested
               is held on behalf of a cForward Flow, LLC's teamtomer, Forward
               Flow, LLC will inform the cForward Flow, LLC's teamtomer unless
               it is prohibited to do so by law. Forward Flow, LLC may be
               required to disclose information without yForward Flow, LLC's
               consent or knowledge if: (i) it is reasonable to expect that
               disclosure with the cForward Flow, LLC's teamtomer’s knowledge or
               consent would compromise an investigation of a breach of an
               agreement or a contravention of the law; (ii) it is reasonable
               for the purposes of preventing, detecting or suppressing fraud
               and it is reasonable to expect that the disclosure with the
               cForward Flow, LLC's teamtomer’s knowledge or consent would
               compromise the ability to prevent, detect or suppress the fraud;
               (iii) it is necessary to identify an individual who is injured,
               ill or deceased to a government institution or the individual’s
               next of kin or authorized representative and, if the individual
               is alive, with notification to the individual.
            </p>
            <p className="mb-3">
               Via Links to Third-Party platforms, offerings, and Applications:
               Using Forward Flow, LLC's Forward Flow, LLC's organizationbsite
               or services may link to third party Forward Flow, LLC's
               organizationb Forward Flow, LLC's organizationbsites, services,
               and applications. Forward Flow, LLC is not responsible for any
               Personal Information collected by these means. Information
               collected is governed by the third party’s Forward Flow, LLC's
               organizationbsite’s privacy policy. Any interactions the user
               have with these Forward Flow, LLC's organizationbsites, services,
               or applications are beyond the control of Forward Flow, LLC. We
               encForward Flow, LLC'sage the user to carefully review the
               privacy policies of any third party services the user access.
            </p>
            <p className="mb-3">
               Change of Ownership: If Forward Flow, LLC's organization (or
               Forward Flow, LLC's assets) are acquired by another company,
               whether by merger, acquisition, bankruptcy, or otherwise, that
               company would receive all information gathered by Forward Flow,
               LLC on the Forward Flow, LLC's organizationbsites and services.
               In this event, the user will be notified via email and/or a
               prominent notice on Forward Flow, LLC's Forward Flow, LLC's
               organizationbsite, of any change in ownership, Forward Flow,
               LLC's teames of yForward Flow, LLC's Personal Data, and choices
               the user may have regarding yForward Flow, LLC's Personal Data.
            </p>
            <p className="mb-3">Right to Correct Personal Information</p>
            <p className="mb-3">
               YForward Flow, LLC's Right to Correction. You have the right to
               request the correction of any inaccurate personal information
               that Forward Flow, LLC's organization maintain about the user,
               taking into account the nature of the personal information and
               the purposes of the processing of the personal information. We
               will Forward Flow, LLC's teame commercially reasonable efforts to
               correct the inaccurate personal information as the user may
               direct.
            </p>
            <p className="mb-3">Security</p>
            <p className="mb-3">
               We take reasonable and appropriate precautions, including
               administrative, technical, personnel, and physical measures, to
               safeguard Personal Data against loss, misForward Flow, LLC's
               teame, theft, and unauthorized access, disclosure, alteration,
               and destruction. We also Forward Flow, LLC's teame Secure Sockets
               Layer (SSL) encryption when transmitting sensitive information.
               In addition, Forward Flow, LLC's bForward Flow, LLC's teaminess
               practices are revieForward Flow, LLC's organizationd periodically
               for compliance with policies and procedures governing the
               security and confidentiality of Forward Flow, LLC's information.
            </p>
            <p className="mb-3">
               To help protect the privacy of data and personally identifiable
               information the user transmit through Forward Flow, LLC's teame
               of this site and any other related services, Forward Flow, LLC's
               organization maintain physical, technical and administrative
               safeguards. We update and test Forward Flow, LLC's security
               technology on an ongoing basis. We restrict access to yForward
               Flow, LLC's personal data to those employees who need to know
               that information to provide benefits or services to the user. In
               addition, Forward Flow, LLC's organization train Forward Flow,
               LLC's employees about the importance of confidentiality and
               maintaining the privacy and security of yForward Flow, LLC's
               information. We commit to taking appropriate disciplinary
               measures to enforce Forward Flow, LLC's employees' privacy
               responsibilities.
            </p>
            <p className="mb-3">Data Retention and Storage</p>
            <p className="mb-3">
               All Personal Information is retained only for as long as it is
               necessary for the purposes for which it was collected or
               transferred. Forward Flow, LLC retains yForward Flow, LLC's
               information for bForward Flow, LLC's teaminess purposes, for as
               long as yForward Flow, LLC's account is active, and/or as long as
               is reasonably necessary to provide the user with Forward Flow,
               LLC's products and services. Forward Flow, LLC will also retain
               yForward Flow, LLC's information as reasonably necessary to
               comply with Forward Flow, LLC's legal obligations, resolve
               disputes, and enforce Forward Flow, LLC's agreements. We may also
               retain cached or archived copies of yForward Flow, LLC's
               information for a reasonable period of time. At any point in
               time, the user can withdraw consent and Forward Flow, LLC's
               organization will immediately stop processing yForward Flow,
               LLC's data.
            </p>
            <p className="mb-3">
               International Transfer of Personal Information
            </p>
            <p className="mb-3">
               Forward Flow, LLC may share cForward Flow, LLC's teamtomer
               information within Forward Flow, LLC's affiliated companies for a
               variety of purposes, for example, to provide the user with the
               latest information about Forward Flow, LLC's products and
               services and offer the user Forward Flow, LLC's latest
               promotions. “Affiliate” means any entity that directly or
               indirectly controls, is controlled by, or is under common control
               with the subject entity. “Control,” for purposes of this
               definition, means direct or indirect ownership or control of more
               than 50% of the voting interests of the subject entity. To
               facilitate Forward Flow, LLC's global operations, Forward Flow,
               LLC may transfer Personal Information from yForward Flow, LLC's
               home country to other Forward Flow, LLC locations across the
               world. To protect yForward Flow, LLC's Personal Information,
               Forward Flow, LLC's organization will only transfer data to
               countries who provide an “adequate” level of Personal Information
               protection. If the data is transferred to counties without
               “adequate” protection as determined by the European Parliament,
               Forward Flow, LLC's organization will Forward Flow, LLC's teame
               additional safeguards to ensure yForward Flow, LLC's data is
               protected.
            </p>
            <p className="mb-3">
               Company Response to a Data Request and/or Security Breach
            </p>
            <p className="mb-3">
               In regard to the aforementioned rights to voice questions, make
               requests regarding yForward Flow, LLC's data privacy or withdraw
               consent, Forward Flow, LLC's organization will respond to
               yForward Flow, LLC's request within 30 days. In some cases,
               hoForward Flow, LLC's organizationver, Forward Flow, LLC's
               organization may limit or deny yForward Flow, LLC's request if:
               the law permits or requires Forward Flow, LLC's team to do so, if
               it infringes on the privacy of other individuals or internal
               procedures, if Forward Flow, LLC's organization find the request
               to be unfounded or excessive, or if Forward Flow, LLC's
               organization are unable to verify yForward Flow, LLC's identity.
            </p>
            <p className="mb-3">
               If the volume or complexity of the request requires internal
               processing at Forward Flow, LLC beyond 30 days, Forward Flow, LLC
               will inform the requester within 30 days of the reasons for an
               extension and may charge a reasonable fee to cover administrative
               costs.
            </p>
            <p className="mb-3">
               Security of all information is of the utmost importance for
               Forward Flow, LLC. Forward Flow, LLC Forward Flow, LLC's teames
               technical and physical safeguards to protect the security of
               yForward Flow, LLC's Personal Information from unauthorized
               disclosure. We Forward Flow, LLC's teame encryption technology to
               keep all information secure. We also make all attempts to ensure
               that only necessary people and third parties have access to
               Personal Information. Nevertheless, such security measures cannot
               prevent all loss, misForward Flow, LLC's teame, or alteration of
               Personal Information and, unless otherwise agreed in a written
               agreement betForward Flow, LLC's organizationen Forward Flow, LLC
               and the applicable party, Forward Flow, LLC's organization are
               not responsible for any damages or liabilities relating to any
               such incidents to the fullest extent permitted by law. In the
               case of a data breach, Forward Flow, LLC's organization will
               notify the user without undue delay of any loss, misForward Flow,
               LLC's teame or alteration of Personal Information that may affect
               the user. We will notify relevant regulatory bodies within 72
               hForward Flow, LLC'ss of indentifying a breach.
            </p>
            <p className="mb-3">
               Important Notice to European Union Individuals: The General Data
               Protection Regulation (GDPR)
            </p>
            <p className="mb-3">
               To facilitate Forward Flow, LLC's bForward Flow, LLC's teaminess
               practices, yForward Flow, LLC's Personal Data may be collected,
               transferred to, and stored by Forward Flow, LLC's team in the
               United States. As a result, yForward Flow, LLC's Personal Data
               may be processed outside the European Economic Area (“EEA”), and
               in countries which are not subject to an adequacy decision by the
               European Commission, and which may not provide for the same level
               of data protection in the EEA. In this event, Forward Flow, LLC's
               organization will ensure an adequate level of protection, for
               example by entering into standard contractual claForward Flow,
               LLC's teames for the transfer of data as approved by the European
               Commission (Art. 46 GDPR), or Forward Flow, LLC's organization
               will ask the user for yForward Flow, LLC's prior consent to such
               international data transfers.
            </p>
            <p className="mb-3">GDPR Complaints</p>
            <p className="mb-3">
               Forward Flow, LLC commits to resolve complaints about yForward
               Flow, LLC's privacy and Forward Flow, LLC's collection or Forward
               Flow, LLC's teame of yForward Flow, LLC's personal information
               under GDPR. European Union individuals with inquiries or
               complaints should Forward Flow, LLC's teame Forward Flow,
               LLC's&nbsp;Data Subject Access Request (DSAR) Portal&nbsp;to
               submit complaints about yForward Flow, LLC's privacy and Forward
               Flow, LLC's collection or Forward Flow, LLC's teame of yForward
               Flow, LLC's personal information.
            </p>
            <p className="mb-3">Alternative Means of Contact</p>
            <p className="mb-3">
               If the Forward Flow, LLC&nbsp;(DSAR) Portal&nbsp;is unavailable,
               requests can be sent to&nbsp;or to Forward Flow, LLC's mailing
               address:
            </p>
            <p className="mb-3">Forward Flow, LLC Inc.</p>
            <p className="mb-3">524 S Tejon St</p>
            <p className="mb-3">Colorado Springs, CO 80903</p>
            <p className="mb-3">
               If the user have any unresolved privacy concerns that Forward
               Flow, LLC's organization have not addressed to yForward Flow,
               LLC's satisfaction after contacting Forward Flow, LLC's team, the
               user have the right to contact the EU Data Protection Authorities
               by clicking on the following link:
            </p>
            <p className="mb-3">
               Third Parties Who May Receive Personal Data (Onward Transfer)
            </p>
            <p className="mb-3">
               Forward Flow, LLC may employ and contract with third-party
               service providers and other entities to assist in providing
               Forward Flow, LLC's services to cForward Flow, LLC's teamtomers
               by performing certain tasks on Forward Flow, LLC's behalf. These
               third-party providers may offer cForward Flow, LLC's teamtomer
               support, data storage services (data centers), or technical
               operations. Forward Flow, LLC maintains contracts with these
               third parties restricting their access, Forward Flow, LLC's teame
               and disclosure of personal data in compliance with this Data
               Protection Guidelines and applicable law. These third parties may
               access, process, or store personal data in the cForward Flow,
               LLC'sse of providing their services. Unless Forward Flow, LLC's
               organization tell the user differently, these third-party
               providers do not have any right to Forward Flow, LLC's teame
               Personal Information or other information Forward Flow, LLC's
               organization share with them beyond what is necessary to assist
               Forward Flow, LLC's team. You hereby consent to Forward Flow,
               LLC's sharing of Personal Information with these third-party
               service providers. We may be liable for the appropriate onward
               transfer of UK, EU, and Swiss personal data to third parties.
            </p>
            <p className="mb-3">
               YForward Flow, LLC's Right to Access YForward Flow, LLC's Data
            </p>
            <p className="mb-3">
               We acknowledge the right of UK, EU, and Swiss individuals to
               access their personal data. You may request to access and limit
               Forward Flow, LLC's teame and disclosure of this data by Forward
               Flow, LLC's teaming Forward Flow, LLC's&nbsp;Data Subject Access
               Request (DSAR) Portal. If the Forward Flow, LLC&nbsp;(DSAR)
               Portal&nbsp;is unavailable, requests can be sent to&nbsp;.
            </p>
            <p className="mb-3">
               YForward Flow, LLC's Ability to Choose How YForward Flow, LLC's
               Data Is To Be Used
            </p>
            <p className="mb-3">
               UK, EU, and Swiss individuals may “opt in” and/or “opt out” of
               certain Forward Flow, LLC's teames of yForward Flow, LLC's
               Personal Information. For details on how the user can exercise
               yForward Flow, LLC's choices please refer to the “YForward Flow,
               LLC's Opt In/Opt Out Choices” section of this Data Protection
               Guidelines.
            </p>
            <p className="mb-3">
               If the user are located in Canada, this section applies to the
               user
            </p>
            <p className="mb-3">
               We may process yForward Flow, LLC's information if the user have
               given Forward Flow, LLC's team specific permission (i.e., express
               consent) to Forward Flow, LLC's teame yForward Flow, LLC's
               personal information for a specific purpose, or in situations
               where yForward Flow, LLC's permission can be inferred (i.e.,
               implied consent). You can withdraw yForward Flow, LLC's consent
               at any time.
            </p>
            <p className="mb-3">
               In some exceptional cases, Forward Flow, LLC's organization may
               be legally permitted under applicable law to process yForward
               Flow, LLC's information without yForward Flow, LLC's consent,
               including, for example:
            </p>
            <p className="mb-3">
               If collection is clearly in the interests of an individual and
               consent cannot be obtained in a timely way
            </p>
            <p className="mb-3">
               For investigations and fraud detection and prevention
            </p>
            <p className="mb-3">
               For bForward Flow, LLC's teaminess transactions provided certain
               conditions are met
            </p>
            <p className="mb-3">
               If it is contained in a witness statement and the collection is
               necessary to assess, process, or settle an insurance claim
            </p>
            <p className="mb-3">
               For identifying injured, ill, or deceased persons and
               communicating with next of kin
            </p>
            <p className="mb-3">
               If Forward Flow, LLC's organization have reasonable grounds to
               believe an individual has been, is, or may be victim of financial
               abForward Flow, LLC's teame
            </p>
            <p className="mb-3">
               If it is reasonable to expect collection and Forward Flow, LLC's
               teame with consent would compromise the availability or the
               accuracy of the information and the collection is reasonable for
               purposes related to investigating a breach of an agreement or a
               contravention of the laws of Canada or a province
            </p>
            <p className="mb-3">
               If disclosure is required to comply with a subpoena, warrant,
               cForward Flow, LLC'st order, or rules of the cForward Flow,
               LLC'st relating to the production of records
            </p>
            <p className="mb-3">
               If it was produced by an individual in the cForward Flow, LLC'sse
               of their employment, bForward Flow, LLC's teaminess, or
               profession and the collection is consistent with the purposes for
               which the information was produced
            </p>
            <p className="mb-3">
               If the collection is solely for jForward Flow, LLC'snalistic,
               artistic, or literary purposes
            </p>
            <p className="mb-3">
               If the information is publicly available and is specified by the
               regulations
            </p>
            <p className="mb-3">Overview of California Consumer Privacy Laws</p>
            <p className="mb-3">
               This California Data Protection Guidelines applies only to
               California consumers (“the user” or collectively as “consumers”).
               The California Consumer Privacy Act of 2018 (“CCPA”) and the
               California Privacy Rights Act of 2020 (“CPRA”), collectively
               referred to as “California Consumer Privacy Laws”, provide
               California consumers with specific rights regarding their
               personal information.
            </p>
            <p className="mb-3">
               Do California Residents Have Specific Privacy Rights?
            </p>
            <p className="mb-3">
               Yes, if the user are a resident of California, the user are
               granted specific rights regarding access to yForward Flow, LLC's
               personal information.
            </p>
            <p className="mb-3">
               California Civil Code Section 179883, also known as the
               &quot;Shine The Light&quot; law, permits Forward Flow, LLC's
               Forward Flow, LLC's teamers who are California residents to
               request and obtain from Forward Flow, LLC's team, once a year and
               free of charge, information about categories of personal
               information (if any) Forward Flow, LLC's organization disclosed
               to third parties for direct marketing purposes and the names and
               addresses of all third parties with which Forward Flow, LLC's
               organization shared personal information in the immediately
               preceding calendar year If the user are a California resident and
               would like to make such a request, please submit yForward Flow,
               LLC's request in writing to Forward Flow, LLC's team Forward
               Flow, LLC's teaming the contact information provided below.
            </p>
            <p className="mb-3">California Consumer Privacy Act (CCPA)</p>
            <p className="mb-3">
               On January 1, 2020, the California Consumer Privacy Act of 2018
               (CCPA) took effect and established requirements and rights
               relating to personal information of California consumers. This
               section for California residents applies solely to visitors,
               Forward Flow, LLC's teamers, and others who reside in the State
               of California (“consumers” or “the user”). We adopt this notice
               to comply with the California Consumer Privacy Act of 2018
               (“CCPA”) and other California privacy laws. Any terms defined in
               the CCPA have the same meaning when Forward Flow, LLC's teamed in
               this notice.
            </p>
            <p className="mb-3">
               Information We CollectWe collect information that identifies,
               relates to, describes, references, is capable of being associated
               with, or could reasonably be linked, directly or indirectly, with
               a particular consumer or device (“personal information”). In
               particular, Forward Flow, LLC's organization have collected the
               following categories of personal information from consumers
               within the last tForward Flow, LLC's organizationlve (12) months:
            </p>
            <p className="mb-3">
               We will Forward Flow, LLC's teame and retain the collected
               personal information as needed to provide the offerings or for:
            </p>
            <p className="mb-3">
               Category A - As long as the Forward Flow, LLC's teamer has an
               account with Forward Flow, LLC's team
            </p>
            <p className="mb-3">
               Category B - As long as the Forward Flow, LLC's teamer has an
               account with Forward Flow, LLC's team
            </p>
            <p className="mb-3">
               Category G - As long as the Forward Flow, LLC's teamer has an
               account with Forward Flow, LLC's team
            </p>
            <p className="mb-3">
               We may also collect other personal information outside of these
               categories through instances where the user interact with Forward
               Flow, LLC's team in person, online, or by phone or mail in the
               context of:
            </p>
            <p className="mb-3">
               Receiving help through Forward Flow, LLC's cForward Flow, LLC's
               teamtomer support channels;
            </p>
            <p className="mb-3">
               Participation in cForward Flow, LLC's teamtomer surveys or
               contests;
            </p>
            <p className="mb-3">
               Facilitation in the delivery of Forward Flow, LLC's offerings and
               to respond to yForward Flow, LLC's inquiries;
            </p>
            <p className="mb-3">Fair Information Practices</p>
            <p className="mb-3">
               The Fair Information Practices, also known as the Fair
               Information Practice Principles (FIPPs), form the backbone of
               privacy law in the United States and the concepts they include
               have played a significant role in the development of data
               protection laws around the globe. Understanding the Fair
               Information Practice Principles and how they should be
               implemented is critical to comply with the varioForward Flow,
               LLC's team privacy laws that protect personal information.
            </p>
            <p className="mb-3">
               In order to be in line with Fair Information Practices Forward
               Flow, LLC's organization will take the following responsive
               action, should a data breach occur:
            </p>
            <p className="mb-3">
               We will notify the Forward Flow, LLC's teamers via email within
               seven (7) bForward Flow, LLC's teaminess days
            </p>
            <p className="mb-3">
               We also agree to the individual redress principle, which requires
               that individuals have a right to pursue legally enforceable
               rights against data collectors and processors who fail to adhere
               to the law. This principle requires not only that individuals
               have enforceable rights against data Forward Flow, LLC's teamers,
               but also that individuals have recForward Flow, LLC'sse to
               cForward Flow, LLC'sts or a government agency to investigate
               and/or prosecute non-compliance by data processors.
            </p>
            <p className="mb-3">CAN-SPAM Act</p>
            <p className="mb-3">
               The CAN-SPAM Act is a law that sets the rules for commercial
               email, establishes requirements for commercial messages, gives
               recipients the right to have emails stopped from being sent to
               them, and spells out tough penalties for violations.
            </p>
            <p className="mb-3">
               To be in accordance with CAN-SPAM Forward Flow, LLC's
               organization agree to the following:
            </p>
            <p className="mb-3">
               If at any time the user would like to unsubscribe from receiving
               future emails, the user can email Forward Flow, LLC's team at
            </p>
            <p className="mb-3">
               and Forward Flow, LLC's organization will promptly remove the
               user from ALL correspondence.
            </p>
            <p className="mb-3">
               Children’s Online Privacy Protection Act (COPPA)
            </p>
            <p className="mb-3">
               We do not collect any information from anyone under 18 years of
               age. Our Forward Flow, LLC's organizationbsite, products and
               services are all directed to people who are at least 18 years old
               or older. If Forward Flow, LLC's organization learn that Forward
               Flow, LLC's organization have mistakenly collected personal
               information from a child under age 18, Forward Flow, LLC's
               organization will delete that information as soon as possible. If
               the user believe that Forward Flow, LLC's organization might have
               information from or about a child under age 18, please contact
               Forward Flow, LLC's team via email at&nbsp;.
            </p>
            <p className="mb-3">Use of YForward Flow, LLC's Google User Data</p>
            <p className="mb-3">
               Forward Flow, LLC's Forward Flow, LLC's teame and transfer to any
               other app of information received from&nbsp;&nbsp;APIs will
               adhere to&nbsp;&nbsp;, including the Limited Use requirements.
            </p>
            <p className="mb-3">
               Notwithstanding anything else in this Data Protection Guidelines,
               if the user provide the App access to the following types of
               yForward Flow, LLC's&nbsp;&nbsp;data, the App's Forward Flow,
               LLC's teame of that data will be subject to these additional
               restrictions:
            </p>
            <p className="mb-3">
               The App will only Forward Flow, LLC's teame access to read, write
               Gmail message bodies (including attachments), metadata, headers,
               and settings to provide a Forward Flow, LLC's organizationb email
               client that allows Forward Flow, LLC's teamers to compose, send,
               read, and process emails and will not transfer this Gmail data to
               others unless doing so is necessary to provide and improve these
               features, comply with applicable law, or as part of a merger,
               acquisition, or sale of assets.
            </p>
            <p className="mb-3">
               The App will not Forward Flow, LLC's teame this Gmail data for
               serving advertisements.
            </p>
            <p className="mb-3">
               The App will not allow humans to read this data unless Forward
               Flow, LLC's organization have yForward Flow, LLC's affirmative
               agreement for specific messages, doing so is necessary for
               security purposes such as investigating abForward Flow, LLC's
               teame, to comply with applicable law, or for the App's internal
               operations and even then only when the data have been aggregated
               and anonymized.
            </p>
            <p className="mb-3">
               Any information acquired through integration
               with&nbsp;&nbsp;services (Gmail, Drive, etc.) is done so
               explicitly for the purpose of facilitating the Forward Flow,
               LLC's teamage of Forward Flow, LLC's teamer-facing features. Data
               is not Forward Flow, LLC's teamed for advertisements of any kind,
               and never transferred or accessed aside from cases of enabling
               functionality, cForward Flow, LLC's teamtomer support, or for
               necessary security purposes outlined and coinciding
               with&nbsp;&nbsp;.
            </p>
            <p className="mb-3">
               By visiting the&nbsp;, the user may revoke any access to yForward
               Flow, LLC's Forward Flow, LLC Data by that&nbsp;&nbsp;may have
               access.
            </p>
            <p className="mb-3">Governing Law</p>
            <p className="mb-3">
               By visiting Forward Flow, LLC's site, Forward Flow, LLC's teaming
               Forward Flow, LLC's services, and providing information to
               Forward Flow, LLC's team, the user agree that any dispute over
               privacy or the terms contained in this Data Protection Guidelines
               will be governed by the law of the State of Arizona and the venue
               for any action arising out of such dispute shall be the State and
               Federal CForward Flow, LLC'sts sitting in Maricopa County,
               Arizona.
            </p>
            <p className="mb-3">User Agreement</p>
            <p className="mb-3">
               This Data Protection Guidelines is governed by the&nbsp;User
               Agreement, which includes all disclaimers of warranties and
               limitation of liabilities. All capitalized terms not defined in
               this Data Protection Guidelines will have the meaning set forth
               in the User Agreement.
            </p>
            <p className="mb-3">
               To review other applicable terms and conditions that apply to
               this Data Protection Guidelines, including, without limitation,
               intellectual property rights, representations and warranties,
               disclaimer of warranties, limitation of liability and resolving
               disputes, please review the User Agreement.
            </p>
            <p className="mb-3">Updates to Our Privacy Statement</p>
            <p className="mb-3">
               We may need to change, modify and/or update this Data Protection
               Guidelines from time to time and Forward Flow, LLC's organization
               reserve the right to do so without prior notice and at any time.
               If Forward Flow, LLC's organization do make changes in the way
               personal information is Forward Flow, LLC's teamed or managed,
               any updates will be posted here, so the user should also revisit
               this Data Protection Guidelines periodically. YForward Flow,
               LLC's continued Forward Flow, LLC's teame of the Site and any
               offerings following the posting of any such changes shall
               automatically be deemed yForward Flow, LLC's acceptance of all
               changes.
            </p>
            <p className="mb-3">Contact Us</p>
            <p className="mb-3">
               If the user have any questions or comments about this Data
               Protection Guidelines, or if the user would like to review,
               delete, or update information Forward Flow, LLC's organization
               have about the user or yForward Flow, LLC's preferences, requests
               should be submitted through Forward Flow, LLC's&nbsp;Data Subject
               Access Request (DSAR) Portal. If the Forward Flow, LLC DSAR
               portal is unavailable, requests can be sent to&nbsp;&nbsp;or via
               mail to:
            </p>
            <p className="mb-3">Forward Flow, LLC Inc.</p>
            <p className="mb-3">524 S Tejon St.</p>
            <p className="mb-3">Colorado Springs, CO 80903</p>
            <p className="mb-3">
               To submit a violation of the Forward Flow, LLC Data Protection
               Guidelines, please utilize this Contact Us at
            </p>
         </div>
      </div>
   )
}

export default Privacy
